"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setTime = exports.getTime = exports.isValidTime = exports.isValidDate = exports.toISO = exports.replaceFormat = exports.addDate = exports.daysInMonth = exports.monthFirstDayOfWeek = exports.formatDate = exports.isSame = exports.isAfter = exports.isBefore = exports.isToday = exports.getYearByDate = exports.getMonthByDate = exports.getMonths = exports.getWeakShort = exports.setLocale = void 0;
var dayjs_1 = __importDefault(require("dayjs"));
var customParseFormat_1 = __importDefault(require("dayjs/plugin/customParseFormat"));
var localeData_1 = __importDefault(require("dayjs/plugin/localeData"));
var localizedFormat_1 = __importDefault(require("dayjs/plugin/localizedFormat"));
var updateLocale_1 = __importDefault(require("dayjs/plugin/updateLocale"));
var weekday_1 = __importDefault(require("dayjs/plugin/weekday"));
require("dayjs/locale/ru");
require("dayjs/locale/he");
require("dayjs/locale/hy-am");
require("dayjs/locale/kk");
require("dayjs/locale/be");
dayjs_1.default.extend(localeData_1.default);
dayjs_1.default.extend(updateLocale_1.default);
dayjs_1.default.extend(weekday_1.default);
dayjs_1.default.extend(customParseFormat_1.default);
dayjs_1.default.extend(localizedFormat_1.default);
dayjs_1.default.updateLocale('ru', {
    weekdays: 'понедельник_вторник_среда_четверг_пятница_суббота_воскресенье'.split('_'),
    weekdaysShort: 'пнд_втр_срд_чтв_птн_сбт_вск'.split('_'),
    weekdaysMin: 'пн_вт_ср_чт_пт_сб_вс'.split('_'),
    weekStart: 1,
});
function setLocale(locale) {
    return dayjs_1.default.locale(locale);
}
exports.setLocale = setLocale;
function getWeakShort() {
    return dayjs_1.default.weekdaysShort();
}
exports.getWeakShort = getWeakShort;
function getMonths() {
    return dayjs_1.default.months();
}
exports.getMonths = getMonths;
function getMonthByDate(date) {
    return (0, dayjs_1.default)(date).get('month');
}
exports.getMonthByDate = getMonthByDate;
function getYearByDate(date) {
    return (0, dayjs_1.default)(date).get('year');
}
exports.getYearByDate = getYearByDate;
function isToday(date) {
    var d = (0, dayjs_1.default)(date);
    var now = (0, dayjs_1.default)();
    return d.year() === now.year() && d.month() === now.month() && d.date() === now.date();
}
exports.isToday = isToday;
function isBefore(date1, date2, accuracy) {
    if (accuracy === void 0) { accuracy = 'millisecond'; }
    var d1 = (0, dayjs_1.default)(date1);
    var d2 = (0, dayjs_1.default)(date2);
    return d1.isBefore(d2, accuracy);
}
exports.isBefore = isBefore;
function isAfter(date1, date2, accuracy) {
    if (accuracy === void 0) { accuracy = 'millisecond'; }
    var d1 = (0, dayjs_1.default)(date1);
    var d2 = (0, dayjs_1.default)(date2);
    return d1.isAfter(d2, accuracy);
}
exports.isAfter = isAfter;
function isSame(date1, date2, accuracy) {
    if (accuracy === void 0) { accuracy = 'millisecond'; }
    var d1 = (0, dayjs_1.default)(date1);
    var d2 = (0, dayjs_1.default)(date2);
    return d1.isSame(d2, accuracy);
}
exports.isSame = isSame;
function formatDate(date, format) {
    return (0, dayjs_1.default)(date).format(format);
}
exports.formatDate = formatDate;
function monthFirstDayOfWeek(month, year) {
    var firstMonthDate = (0, dayjs_1.default)(new Date(year, month, 1));
    return firstMonthDate.weekday();
}
exports.monthFirstDayOfWeek = monthFirstDayOfWeek;
function daysInMonth(month, year) {
    var firstMonthDate = (0, dayjs_1.default)(new Date(year, month, 1));
    return firstMonthDate.daysInMonth();
}
exports.daysInMonth = daysInMonth;
function addDate(date, value) {
    return (0, dayjs_1.default)(date).date(value).format();
}
exports.addDate = addDate;
function replaceFormat(date, fromFormat, toFormat) {
    return (0, dayjs_1.default)(date, fromFormat, true).format(toFormat);
}
exports.replaceFormat = replaceFormat;
function toISO(date, format) {
    return replaceFormat(date, format, undefined);
}
exports.toISO = toISO;
function isValidDate(date, format) {
    return (0, dayjs_1.default)(date, format, true).isValid();
}
exports.isValidDate = isValidDate;
function isValidTime(time) {
    return new RegExp(/^([01]\d|2[0-3]):[0-5][0-9]$/).test(time);
}
exports.isValidTime = isValidTime;
function getTime(date, dateFormat) {
    var d = (0, dayjs_1.default)(date, dateFormat, true);
    if (d.isValid()) {
        return d.format('HH:mm');
    }
    return '';
}
exports.getTime = getTime;
function setTime(date, time, dateFormat, timeFallback) {
    if (!isValidTime(time)) {
        if (timeFallback) {
            return setTime(date, timeFallback, dateFormat);
        }
        return date;
    }
    var _a = __read(time.split(':').map(Number), 2), h = _a[0], m = _a[1];
    return (0, dayjs_1.default)(date, dateFormat, true).set('hours', h).set('minutes', m).format(dateFormat);
}
exports.setTime = setTime;
